import {Link} from 'react-router-dom';
import React/*, {useState}*/ from 'react';

import {useracc, postApi, consoleLog} from '../../../utils/functions';
import {UserContext, TestService} from '../../../utils/usercontext';
//import EventEmitter from '../../../utils/emmiter';
import VideoPlayer from '../video/video';
import Blocks from '../bbcode/blocks';
import moment from 'moment';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

export default class PortalOverview extends React.Component {
  static contextType = UserContext;
  constructor(props) {
    super(props);
    this.state = {
			status: false,
			
			service: {},
			//invite: [],
			invites: [],
      admins: [],
      members: [],
      stage: {},
      schedule: [],
      next: [],
		};
		this.getOverview = this.getOverview.bind(this);
    this.timeAgo = this.timeAgo.bind(this);
  };

  async componentDidMount() {
    const value = this.context;
		const getUser = await useracc();
		value.setUser( getUser );
		value.setTheme( getUser );
    await value.setWorker( this.props.service );
		this.getOverview();
	}

  async getOverview() {
    const value = this.context;
    let params = new URLSearchParams();
		params.append('service', this.props.service);
		const x = await postApi(`${value.worker[this.props.service]}/v3/service/overview`, params);
    consoleLog(x.data);
    this.setState({
      status: true,
      service: x.data.service||{},
			//invite: [],
			invites: x.data.invites||[],
      admins: x.data.admins||[],
      members: x.data.members||[],
      stage: x.data.stage||{},
      schedule: x.data.schedule||[],
      next: x.data.next||[],
    });
  }

  timeAgo(time) {
		let date = new Date();
		const _time = Math.floor( Math.abs((Date.now()/1000+date.getTimezoneOffset() * 60) - time) / 60) ;
		let past = time < Math.floor(Date.now()/1000+date.getTimezoneOffset() * 60);
		let _return = '';
    if( _time < 1 ) return( <>Online</> );
		if( _time >= 1 ) _return = Math.floor(_time).toString() + " mins";
		if( _time >= 60 ) _return = Math.floor(_time/60).toString() + " hour" + (Math.floor(_time/60)>1?"s":"");
		if( _time >= 1440 ) _return = Math.floor(_time/1440).toString() + " day" + (Math.floor(_time/1440)>1?"s":"");
		return( <>{!past&&'In '}{_return}{past&&' ago'}</> );
	}

  render() {
    const user = this.context;

    const admins = this.state.admins.map((e,i) => {
			return (
        <OverlayTrigger
          key={i}
          placement="right"
          delay={{ show: 250, hide: 400 }}
          overlay={<Tooltip id="button-tooltip">
            <>{e.title?e.title:e.username} {e.id_level===40?'(Owner)':'(Admin)'}</>
          </Tooltip>}
        >
          <Link to={`/profile/${e.username}`} key={i} className="avatar avatar-md" >
            <img alt="avatar" className="rounded-circle" src={`https://cloud.ultrastream.io${e.avatar}`} />
          </Link>
        </OverlayTrigger>
      )
    });

    const members = this.state.members.map((e,i) => {
			return (
        <OverlayTrigger
          key={i}
          placement="right"
          delay={{ show: 250, hide: 400 }}
          overlay={<Tooltip id="button-tooltip">
            {e.title?e.title:e.username}
          </Tooltip>}
        >
          <Link to={`/profile/${e.username}`} key={i} className="avatar avatar-md" >
            <img alt="avatar" className="rounded-circle" src={`https://cloud.ultrastream.io${e.avatar}`} />
          </Link>
        </OverlayTrigger>
      )
    });

    const schedule = this.state.schedule.filter(elem=>elem.cancelled===0).map((e,i) => {
      return (
        <li key={i} className="list-group-item">
          <div className="d-flex align-items-center">
            <span className="avatar avatar-md">
              <img src={`https://cloud.ultrastream.io${e.avatar}`} alt="img" />
            </span>
            <div className="ms-2 fw-semibold">
              {e.title?e.title:e.usertitle?e.usertitle:e.username}<br />
              <span>{moment(e.start).format("h:mm A")} - {moment(e.end).format("h:mm A")}</span>
            </div>
          </div>
        </li>
      )
    });

    const online_admins = this.state.admins.map((e,i) => {
			return (
				<li key={i}>
					<Link to={`/profile/${e.username}`}>
						<div className="d-flex align-items-center">
							<div className="me-2 d-flex align-items-center">
								<span className={`avatar avatar-sm avatar-rounded ${'online'}`}>
									<img src={`https://cloud.ultrastream.io${e.avatar}`} alt="" className="rounded-circle" />
								</span>
								</div>
								<div className="flex-fill">
									<span>{e.title?e.title:e.username}</span>
								</div>
								<div>
									<span className="fs-10 fw-semibold text-muted">{this.timeAgo(e.lastconnect)}</span>
								</div>
						</div>
					</Link>
				</li>
			)
		});
		const online_members = this.state.members.map((e,i) => {
			return (
				<li key={i}>
					<Link to={`/profile/${e.username}`}>
						<div className="d-flex align-items-center">
							<div className="me-2 d-flex align-items-center">
								<span className={`avatar avatar-sm avatar-rounded ${'online'}`}>
									<img src={`https://cloud.ultrastream.io${e.avatar}`} alt="" className="rounded-circle" />
								</span>
								</div>
								<div className="flex-fill">
									<span>{e.title?e.title:e.username}</span>
								</div>
								<div>
									<span className="fs-10 fw-semibold text-muted">{this.timeAgo(e.lastconnect)}</span>
								</div>
						</div>
					</Link>
				</li>
			)
		});

		return (
			<>
        {this.state.status === true &&
          <>
            {this.props.version === 'full' &&
              <Col sm={12}>
                <div className="card custom-card">
                  <div className="d-flex p-3 border-bottom-0">
                    <div className="">
                      <svg className="me-4  bg-success-transparent  alt-notify" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="#75cfa5" d="m20.34 9.32-13.99-7a3 3 0 0 0-4.08 3.9L4.41 11l.26.59a1.06 1.06 0 0 1 0 .82l-.26.59-2.14 4.78a2.954 2.954 0 0 0 .67 3.38A2.966 2.966 0 0 0 5 22a3.141 3.141 0 0 0 1.35-.32l13.99-7a2.993 2.993 0 0 0 0-5.36Z"></path><path fill="#198754" d="M14.46 12a.997.997 0 0 1-1 1H4.41l.26-.59a1.06 1.06 0 0 0 0-.82L4.41 11h9.05a.997.997 0 0 1 1 1Z"></path></svg>
                    </div>
                    <div className="mt-0 text-start">
                      <span className="fs-14 fw-semibold">{this.state.service.name}</span>
                      <p className="fs-13 text-muted mb-0">An overview and outlook of your {this.state.service?.title}.</p>
                    </div>
                  </div>
                  <TestService service={this.state.service.id} worker={user.worker[this.state.service.id]} />
                </div>
              </Col>
            }
            <Col md={this.props.version === 'full'?9:6} sm={12}>
              <div className="card custom-card product-card">
                <div className="card-header">
                  <h5 className="product-name fs-16 fw-semibold mb-0 align-items-center">{this.state.service.title}</h5>
                </div>
                <div className="card-body p-0">
                  <Row className="gx-0 p-3 m-0">
                    {Object.keys(this.state.stage).length === 0 ?
                      <>
                        <div style={{width: 192}}>
                          <img src={`https://cloud.ultrastream.io/images/${this.state.service.avatar}`} width={'90%'} alt="Avatar" />
                        </div>
                        <Col>
                          <div className="flex-1">
                            <p className="tx-capitalize mb-1 fs-14 fw-semibiold">{this.state.service.title} - Idle</p>
                            <p className="tx-capitalize mb-1 fs-14 fw-semibiold">Admins {this.state.service.adminsMax}</p>
                            <div className="d-flex">
                              <div className="avatar-list-stacked">
                                {admins}
                              </div>
                            </div>
                            <p className="tx-capitalize mb-1 fs-14 fw-semibiold">Members {this.state.service.membersMax}</p>
                            <div className="d-flex">
                              <div className="avatar-list-stacked">
                                {members}
                              </div>
                            </div>
                          </div>
                        </Col>
                      </>
                    :
                      <>
                        <Col xs={12}>
                          <VideoPlayer
                            id="video"
                            service={this.props.service} //{this.state.select.address}
                            //select={this.state.select_temp.select}
                            autoPlay={true}
                            uid={user.user.user.id}
                            theatre={this.theatre}
                            onError={this.onError}
                            height={this.state.meta?.video?.height}
                          />
                        </Col>
                        <Col>
                          <div className="d-flex align-items-center my-2">
                            <div className="avatar">
                              <img src={`https://cloud.ultrastream.io${this.state.stage.avatar}`} alt="avatar" />
                            </div>
                            <div className="fw-semibold">
                              {this.state.stage.title?this.state.stage.title:this.state.stage.username} - 9 Viewers<br />
                            </div>
                          </div>
                        </Col>
                      </>
                    }
                  </Row>

                  <ul className="list-group">
                    <li className="list-group-item">
                      <div className="d-flex align-items-center">
                        <span className="avatar avatar-sm">
                          <img src={`https://cloud.ultrastream.io/images/${this.state.service.avatar}`} alt="img" />
                        </span>
                        <div className="ms-2 fw-semibold">
                          {this.state.service.showname}
                        </div>
                      </div>
                    </li>
                    {this.state.schedule.length === 0 &&
                      <li className="list-group-item">
                      <div className="d-flex align-items-center">
                        <div className="ms-2 fw-semibold text-muted">
                          No schedule bookings, <Link to={`/${this.props.service}/schedule`}>View Schedule</Link>
                        </div>
                      </div>
                    </li>
                    }
                    {schedule}
                  </ul>

                  <div className="product-description fs-13 text-muted mb-0 p-3">
                    <Blocks id={`editor-${this.state.service.id}`} blocks={this.state.service.description} />
                    
                  </div>
                  
                  {/*<p className="badge bg-secondary-transparent fs-11 rounded-1 mb-0">72% off</p>
                  <span className="badge bg-warning-transparent rounded-1">4.2 <i className="ri-star-s-fill align-middle  d-inline-block"></i> </span>
                  <span className="text-muted">(12,456)</span>
                  <p className="fs-11 text-success fw-semibold mb-0 align-items-center"> Free Delivery </p>
                  <div className="mt-2">
                    <a href="wishlist.html" className="btn btn-sm btn-danger-light me-1"><i className="ri-heart-line"></i></a>
                    <a href="cart.html" className="btn btn-sm btn-info-light me-1"><i className="ri-shopping-cart-line"></i></a>
                    <a href="product-details.html" className="btn btn-sm btn-success-light"><i className="ri-eye-line"></i></a>
                  </div>*/}
                    
                </div> 
              </div>
            </Col>
            {this.props.version === 'full' &&
              <Col lg={3}>
                <div className="team-groups">
                  <div className="card custom-card">
                    <div className="card-header d-flex align-items-center justify-content-between">
                      <h6 className="fw-semibold mb-0">Radio Team</h6>
                    </div>
                    <div className="card-body p-0">
                      <div className="teams-nav" id="teams-nav" data-simplebar="init">
                        <div className="simplebar-wrapper" style={{margin: 0}}>
                          <div className="simplebar-height-auto-observer-wrapper">
                              <div className="simplebar-height-auto-observer"></div>
                          </div>
                          
                              <div className="simplebar-content-wrapper" tabIndex="0" role="region" aria-label="scrollable content" >
                                <div className="simplebar-content" style={{padding: 0}}>
                                  <ul className="list-unstyled mb-0 mt-2">
                                    <li className="pb-0">
                                      <div className="d-flex justify-content-between align-items-center">
                                        <div className="fs-10 fw-semibold mb-2 text-muted">OWNER / ADMINS</div>
                                      </div>
                                    </li>
                                    {online_admins}
                                    <li className="pb-0">
                                      <div className="d-flex justify-content-between align-items-center">
                                        <div className="fs-10 fw-semibold mb-2 text-muted">DJ TEAM (Latest Online)</div>
                                      </div>
                                    </li>
                                    {online_members}
                                  </ul>
                                </div>
                              </div>
                            
                          {/*<div className="simplebar-placeholder" style={{width: 'auto', height: 890}}></div>*/}
                        </div>
                        <div className="simplebar-track simplebar-horizontal" style={{visibility: 'hidden'}}>
                          <div className="simplebar-scrollbar" style={{width: 0, display: 'none'}}></div>
                        </div>
                        <div className="simplebar-track simplebar-vertical" style={{visibility: 'hidden'}}>
                          <div className="simplebar-scrollbar" style={{height: 728, transform: 'translate3d(0px, 0px, 0px)', display: 'block'}}></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
            }
          </>
        }
      </>
    )
  }
}


